// material-ui
import { MenuItem, TextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';

import {
  EHeaderBidder_InventoryType,
  TitleToHeaderBidderInventoryTypesMap,
} from '~/src/dash/api/headerbidders/headerbidders_models';

interface IBidderInventoryTypeSelectProps {
  name: string;
  onChange: (bidderTypeKey: React.ChangeEvent) => void;
  value: EHeaderBidder_InventoryType;
  label?: string;
  fullWidth?: boolean;
  error?: boolean;
  helperText?: string;
}

const useStyles = makeStyles({
  input: {
    fontSize: 14,
    borderBottom: '1px solid black',
  },
});

export const BidderInventoryTypeSelect = ({
  onChange,
  value,
  name,
  label,
  fullWidth,
  error,
  helperText,
}: IBidderInventoryTypeSelectProps) => {
  const classes = useStyles();
  return (
    <TextField
      name={name}
      select
      label={label}
      fullWidth={fullWidth}
      onChange={onChange}
      value={value}
      error={error}
      helperText={helperText}
      InputProps={{
        disableUnderline: true,
        classes: {
          input: classes.input,
        },
      }}
    >
      {Object.keys(TitleToHeaderBidderInventoryTypesMap).map((inventoryTypeTitle) => {
        return (
          <MenuItem
            key={TitleToHeaderBidderInventoryTypesMap[inventoryTypeTitle]}
            value={TitleToHeaderBidderInventoryTypesMap[inventoryTypeTitle]}
            style={{ fontSize: 14 }}
          >
            {inventoryTypeTitle}
          </MenuItem>
        );
      })}
    </TextField>
  );
};
